<div class="root">
  <router-outlet automation-id="app_routeroutlet"></router-outlet>
</div>
